var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: 32,
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    className: "uk-preserve",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1235_13413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.997 4L15.8359 4.54693V20.4161L15.997 20.5767L23.3631 16.2225L15.997 4Z",
    className: "uk-preserve",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9952 4L8.62891 16.2225L15.9952 20.5767V12.8743V4Z",
    className: "uk-preserve",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.997 21.9713L15.9062 22.082V27.7348L15.997 27.9997L23.3677 17.6194L15.997 21.9713Z",
    className: "uk-preserve",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9952 27.9997V21.9713L8.62891 17.6194L15.9952 27.9997Z",
    className: "uk-preserve",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9941 20.5767L23.3603 16.2225L15.9941 12.8742V20.5767Z",
    className: "uk-preserve",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62891 16.2225L15.9952 20.5767V12.8742L8.62891 16.2225Z",
    className: "uk-preserve",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1235_13413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    className: "uk-preserve",
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.ff37691730703d3c7518f9bcb0157541.svg";
export { ForwardRef as ReactComponent };